import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { cfetch } from '@confluence/network';

export type SiteTraits = {
	attributes: Array<{
		name: string;
		value: string;
	}> | null;
};

export async function fetchSiteTraits(cloudId: string): Promise<SiteTraits> {
	const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;

	const controller = new AbortController();
	const timeout = setTimeout(() => controller.abort(), 250);

	try {
		return await cfetch(url, { method: 'GET', signal: controller.signal }).then(
			async (res: Response) => {
				if (!res.ok) throw new Error();

				return (await res.json()) as SiteTraits;
			},
		);
	} finally {
		clearTimeout(timeout);
	}
}

export const preloadSiteTraits = async (): Promise<void> => {
	if (window.__SSR_SITE_TRAITS__) {
		return;
	}

	const { accessStatus, cloudId } = getPreloaderFnContext();

	if (accessStatus !== 'LICENSED_USE_ACCESS' && accessStatus !== 'LICENSED_ADMIN_ACCESS') {
		return;
	}

	if (!cloudId) {
		return;
	}

	try {
		const data = await fetchSiteTraits(cloudId);
		window.__SSR_SITE_TRAITS__ = data;
	} catch (error) {
		return;
	}
};
